import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { IconsProviderModule } from './icons-provider.module';
import { provideNzI18n } from 'ng-zorro-antd/i18n';
import { en_US } from 'ng-zorro-antd/i18n';
import { CommonModule, registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HTTP_INTERCEPTORS, provideHttpClient } from '@angular/common/http';
import { ComponentsModule } from './components/components.module';
import { LoginComponent } from './login/login.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { NgZorroAntdModule } from './ng-zorro-antd.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ApiService } from './services/api.service';
import { APIServiceInterceptor } from './interceptors/api-service.interceptor';
import Quill from 'quill';
import { MentionBlot, Mention } from 'quill-mention';
 
registerLocaleData(en);

@NgModule({
  declarations: [
    AppComponent,
    SidebarComponent,
    LoginComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    ComponentsModule,
    IconsProviderModule,
    NgZorroAntdModule,
  
  ],
  providers: [
    ApiService,
    { provide: HTTP_INTERCEPTORS, useClass: APIServiceInterceptor, multi: true },
    provideNzI18n(en_US),
    provideAnimationsAsync(),
    provideHttpClient(),
     {
      provide: APP_INITIALIZER,
      useFactory: () => {
        // Register Mention blot first
        if (!Quill.imports['blots/mention']) {
          Quill.register('blots/mention', MentionBlot);
        }

        // Register Mention module
        if (!Quill.imports['modules/mention']) {
          Quill.register('modules/mention', Mention);
        }

        return () => {};
      },
      deps: [],
      multi: true,
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
